/** 成绩提交：构建载荷 → HMAC-SHA256 签名 → POST /score。练习模式不调用。 */
import type { BoardMode } from '../core/types';
import { API_BASE } from './api';
import { canonicalJSON } from './canonical';
import { detectRegion } from './region';
import type { ClientIdentity } from './identity';

export interface RunSummary {
  date: string;
  mode: BoardMode;
  score: number;
  kills: number;
  time: number;
  level: number;
  evolutions: number;
  cause: string;
}

function toHex(buf: ArrayBuffer): string {
  return Array.from(new Uint8Array(buf), (b) =>
    b.toString(16).padStart(2, '0')).join('');
}

function randomNonce(): string {
  const b = new Uint8Array(8);
  crypto.getRandomValues(b);
  return toHex(b.buffer);
}

export async function submitScore(
  id: ClientIdentity,
  s: RunSummary,
): Promise<void> {
  if (!id.secret) throw new Error('missing signing secret');
  const body = {
    token: id.token,
    name: id.name,
    date: s.date,
    mode: s.mode,
    region: detectRegion(),
    score: s.score,
    kills: s.kills,
    time: Math.round(s.time),
    level: s.level,
    evolutions: s.evolutions,
    cause: s.cause,
    nonce: randomNonce(),
  };
  const message = canonicalJSON(body);
  const key = await crypto.subtle.importKey(
    'raw', new TextEncoder().encode(id.secret),
    { name: 'HMAC', hash: 'SHA-256' }, false, ['sign'],
  );
  const sig = toHex(
    await crypto.subtle.sign('HMAC', key, new TextEncoder().encode(message)),
  );
  const r = await fetch(`${API_BASE}/score`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'x-signature': sig,
    },
    body: JSON.stringify(body),
  });
  if (!r.ok) {
    let detail = 'submit failed';
    try {
      detail = String((await r.json()).error ?? detail);
    } catch { /* keep default */ }
    throw new Error(detail);
  }
}
